export default __webpack_public_path__ + "static/media/MathsmaniaCity-Decimal.f86d92b5.png";